import {
  Button,
  Card,
  Checkbox,
  Dialog,
  Input,
  Message,
  Select,
} from '@alifd/next';
import { Form, Modal, Space, Switch, Table, Typography } from 'antd';
import axios from 'axios';
import { history } from 'ice';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import Template from '../../../BroadcastAdd/components/BroadcastAddList/template';
import EditTemplateContent from './editTemplateContent';
import styles from './index.module.scss';
import PreviewTemplateContent from './previewTemplateContent';

const BroadCastList = () => {
  const [formEdit] = Form.useForm();
  const uploadRef = useRef(null);
  const broadcast = client.service('broadcast');
  const broadcastBox = client.service('broadcastBoxs');
  const [broadcastData, setBroadcastData] = useState([]);
  const [broadcastBoxData, setBroadcastBoxData] = useState([]);
  const [broadcastPreview, setBroadcastPreview] = useState();
  const [broadcastContent, setBroadcastContent] = useState();
  const [broadcastId, setBroadcastId] = useState();
  const [editBroadcast, setEditBroadcast] = useState(false);
  const [showBroadcast, setShowBroadcast] = useState(false);
  const [settingBroadcast, setSettingBroadcast] = useState(false);
  const [checkBroadcastBox, setCheckBroadcastBox] = useState([]);
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [backgroundMusic, setBackgroundMusic] = useState(null);
  const [changeTemplate, setChangeTemplate] = useState(false);
  const [template, setTemplate] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  console.log(broadcastContent, 'index');

  useEffect(() => {
    (async () => {
      const res = await broadcast.find({
        query: {
          broadcastGroup: { $exists: false },
          $sort: {
            createdTime: -1,
          },
        },
      });
      setBroadcastData(res.data.sort((a, b) => b.createdTime - a.createdTime));
      const res2 = await broadcastBox.find({});

      setBroadcastBoxData(
        res2.data.map((item) => {
          const newItem = {
            label: item.name,
            value: item._id,
          };
          return newItem;
        })
      );
    })();
  }, [broadcast, broadcastBox, isUpdate]);

  // 更新公播列表
  const onFinish = async (value) => {
    let idArray = [broadcastId];
    broadcastPreview.content = broadcastContent;
    broadcastPreview.title = value.title;
    broadcastPreview.full = value.full;
    let NewBackgroundMusic = backgroundMusic;
    if (uploadData) {
      const body = new FormData();
      body.append('files', uploadData);
      const res = await fetch('/newUploads?type=broadcast', {
        method: 'POST',
        body,
        headers: { authorization: window.localStorage['feathers-jwt'] },
      });
      const { showPath, _id } = (await res.json())[0];
      NewBackgroundMusic = {
        path: showPath,
        name: uploadData.name,
        id: _id,
      };
    }
    broadcastPreview.backgroundMusic = NewBackgroundMusic;
    // 打api文字轉語音
    const newTextArr = [];
    for (let i = 0; i < broadcastContent.length; i++) {
      for (let j = 0; j < broadcastContent[i].children.length; j++) {
        if (
          broadcastContent[i].children[j].typeContent === 'text' &&
          broadcastContent[i].children[j].checkTextSound
        ) {
          newTextArr.push(broadcastContent[i].children[j].typeFormat);
        }
      }
    }
    if (newTextArr.length > 0) {
      await axios('/ezcon/api/textToMp3', {
        method: 'POST',
        headers: {
          authorization: window.localStorage['feathers-jwt'],
        },
        data: { text: newTextArr },
      });
    }
    // 更新單獨公播
    await broadcast.patch(broadcastId, broadcastPreview);
    await broadcast
      .find({
        query: {
          broadcastGroup: { $exists: false },
          $sort: {
            createdTime: -1,
          },
        },
      })
      .then((res) => {
        setBroadcastData(res.data);
        setEditBroadcast(false);
      });

    // 同時更新群組公播
    await broadcast
      .find({
        query: { broadcastGroupId: broadcastId },
      })
      .then((res1) => {
        // console.log(res1.data);
        for (let i = 0; i < res1.data.length; i++) {
          const newData = { ...res1.data[i] };
          const index = newData.broadcastGroupId.indexOf(broadcastId);
          newData.broadcastGroup[index] = broadcastPreview;
          broadcast.patch(newData._id, newData);
          idArray.push(newData._id);
        }
      });
    Message.success('資料更新成功');
    // 更新公播盒子
    console.log(broadcastId);
    // for (let j = 0; j < idArray.length; j++) {
    //   broadcastBox.find({ query: { broadcastId: idArray[j] } }).then((res) => {
    //     console.log(res.data);
    //     if (res.data.length > 0) {
    //       for (let i = 0; i < res.data.length; i++) {
    //         console.log('hi');
    //         const newRecord = {
    //           broadcastId: idArray[i],
    //           broadcastBoxsId: [res.data[i]._id],
    //         };

    //         axios('/ezcon/api/enableBroadcast', {
    //           method: 'POST',
    //           headers: {
    //             authorization: window.localStorage['feathers-jwt'],
    //           },
    //           data: newRecord,
    //         })
    //           .then((res) => {
    //             Message.success('資料更新成功並發佈至公播盒');
    //           })
    //           .catch((err) => {
    //             console.log(err);
    //           });
    //       }
    //     } else {
    //       Message.success('資料更新成功');
    //     }
    //   });
    // }
  };
  console.log(broadcastPreview);
  return (
    <>
      <Button
        className={styles.buttonAdd}
        onClick={() => {
          Message.success('準備跳轉請稍候...');
          setTimeout(() => {
            history.push('/ezpro/broadcast/broadcastAdd');
          }, 1000);
        }}
      >
        新增公播
      </Button>
      <Card free>
        <Card.Content>
          <Table
            bordered={true}
            dataSource={broadcastData}
            sortDirections={['descend', 'ascend', 'descend']}
          >
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={150}
              sorter={(a, b) => a.createdTime - b.createdTime}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column title="建立者" dataIndex="userName" width={150} />
            <Table.Column title="名稱" dataIndex="title" width={150} />
            <Table.Column
              title="更新時間"
              sorter={(a, b) => a.createdTime - b.createdTime}
              dataIndex="updatedTime"
              width={150}
              render={(value) => {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
              }}
            />
            <Table.Column
              title="操作"
              width={200}
              lock="right"
              dataIndex="_id"
              render={(value, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setSettingBroadcast(true);
                        setBroadcastId(value);
                      }}
                    >
                      播放
                    </Button>
                    {/* 20220714 暫時關閉預覽功能 */}
                    {/* <Button
                      type="normal"
                      onClick={() => {
                        setBroadcastPreview(record);
                        setBroadcastContent(record.content);
                        setShowBroadcast(true);
                      }}
                    >
                      預覽
                    </Button> */}
                    <Button
                      type="normal"
                      onClick={() => {
                        setBroadcastPreview(record);
                        setBroadcastContent(record.content);
                        setBroadcastId(value);
                        setEditBroadcast(true);
                        setBackgroundMusic(record.backgroundMusic);
                        setUploadData(null);
                        setUploadPath(null);
                        formEdit.setFieldsValue({
                          ...record,
                        });
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除公播(${record.title})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            broadcast.remove(value).then(() => {
                              Swal.fire('刪除!', '此公播已刪除', 'success');
                              broadcast
                                .find({
                                  query: {
                                    broadcastGroup: { $exists: false },
                                    $sort: {
                                      createdTime: -1,
                                    },
                                  },
                                })
                                .then((res) => {
                                  setBroadcastData(res.data);
                                });
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
          {/* 預覽Dialog */}
          <Dialog
            hasMask
            className={styles.dialogWhite}
            open={showBroadcast}
            onOk={() => {
              setShowBroadcast(false);
            }}
            onClose={() => {
              setShowBroadcast(false);
            }}
            onCancel={() => {
              setShowBroadcast(false);
            }}
          >
            <h3>公播預覽</h3>
            <PreviewTemplateContent broadcastPreview={broadcastPreview} />
          </Dialog>
          {/* 編輯Dialog */}
          <Modal
            width={1200}
            hasMask
            className={styles.dialog}
            open={editBroadcast}
            title="公播編輯"
            footer={[
              <Button
                key="submit"
                type="primary"
                onClick={() => formEdit.submit()}
              >
                確認
              </Button>,
              <Button
                key=""
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  setEditBroadcast(false);
                  setIsUpdate((pre) => !pre);
                }}
              >
                取消
              </Button>,
            ]}
            onOk={() => {
              // form.submit();
            }}
            onClose={() => {
              setEditBroadcast(false);
              setIsUpdate((pre) => !pre);
            }}
            onCancel={() => {
              setEditBroadcast(false);
              setIsUpdate((pre) => !pre);
            }}
          >
            {broadcastPreview ? (
              <>
                <Form onFinish={onFinish} form={formEdit}>
                  <Form.Item
                    name="title"
                    label="公播名稱"
                    rules={[
                      {
                        required: true,
                        message: '請輸入公播名稱',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="full"
                    label="是否滿版"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        message: '請選擇是否滿版',
                      },
                    ]}
                  >
                    <Switch checkedChildren="是" unCheckedChildren="否" />
                  </Form.Item>
                  <Form.Item label="公播模版">
                    <Space wrap>
                      <Button
                        onClick={() => {
                          setChangeTemplate(true);
                        }}
                      >
                        更換模版
                      </Button>
                      <>
                        <Typography.Text type="secondary">
                          {broadcastPreview.template === 'one' && '模版一'}
                          {broadcastPreview.template === 'two' && '模版二'}
                          {broadcastPreview.template === 'three' && '模版三'}
                          {broadcastPreview.template === 'four' && '模版四'}
                        </Typography.Text>
                      </>
                    </Space>
                  </Form.Item>
                  <Form.Item label="背景音樂">
                    {/* <Input /> */}
                    <Space wrap>
                      <Button
                        onClick={() => {
                          uploadRef.current.click();
                        }}
                      >
                        {backgroundMusic ? '更換附件' : '上傳附件'}
                      </Button>
                      {uploadData && (
                        <>
                          <Typography.Text type="secondary">
                            {uploadData.name}
                          </Typography.Text>
                          <Button
                            text
                            onClick={() => {
                              setUploadData(null);
                              setUploadPath('');
                            }}
                            style={{ opacity: 0.45 }}
                          >
                            清除
                          </Button>
                        </>
                      )}
                      {!uploadData && backgroundMusic && (
                        <>
                          <Typography.Text type="secondary">
                            {backgroundMusic.name}
                          </Typography.Text>
                          <Button
                            text
                            onClick={() => {
                              setBackgroundMusic(null);
                            }}
                            style={{ opacity: 0.45 }}
                          >
                            清除
                          </Button>
                        </>
                      )}
                    </Space>
                    <input
                      ref={uploadRef}
                      type="file"
                      id="upload"
                      value={uploadPath || ''}
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        setUploadData(file);
                        setUploadPath(e.target.value);
                      }}
                    />
                  </Form.Item>
                </Form>
                {broadcastPreview.content.map((item, index) => (
                  <EditTemplateContent
                    key={index}
                    {...item}
                    index={index}
                    broadcastContent={broadcastContent}
                    setBroadcastContent={setBroadcastContent}
                    template={broadcastPreview.template}
                  />
                ))}
              </>
            ) : null}
          </Modal>
          {/* 選擇播放機盒 */}
          <Dialog
            hasMask
            className={styles.settingDialog}
            visible={settingBroadcast}
            onOk={() => {
              const newRecord = {
                broadcastId,
                broadcastBoxsId: checkBroadcastBox,
              };

              axios('/ezcon/api/enableBroadcast', {
                method: 'POST',
                headers: {
                  authorization: window.localStorage['feathers-jwt'],
                },
                data: newRecord,
              })
                .then(() => {
                  setSettingBroadcast(false);
                })
                .catch((err) => {
                  console.log(err);
                });
            }}
            onClose={() => {
              setSettingBroadcast(false);
            }}
            onCancel={() => {
              setSettingBroadcast(false);
            }}
          >
            <h3>選擇播放機盒</h3>
            <Checkbox.Group
              dataSource={broadcastBoxData}
              onChange={(value) => setCheckBroadcastBox(value)}
            />
          </Dialog>
          {/* 更換模版 */}
          <Dialog
            hasMask
            className={styles.TemplateDialog}
            visible={changeTemplate}
            title="請選擇模版"
            onOk={() => {
              Swal.fire({
                title: '您確定要更換模版嗎?',
                text: '更換模版將會遺失所有設定!!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#BEBEBE',
                confirmButtonText: '確定',
                cancelButtonText: '取消',
              }).then((result) => {
                if (result.isConfirmed) {
                  const newBroadcastPreview = { ...broadcastPreview };
                  newBroadcastPreview.template = template;
                  if (template === 'one') {
                    newBroadcastPreview.content = [
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 100,
                        children: [],
                      },
                    ];
                  } else if (template === 'two' || template === 'three') {
                    newBroadcastPreview.content = [
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 50,
                        children: [],
                      },
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 50,
                        children: [],
                      },
                    ];
                  } else if (template === 'four') {
                    newBroadcastPreview.content = [
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 30,
                        children: [],
                      },
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 70,
                        children: [],
                      },
                      {
                        carousel: true,
                        color: '#FFFFFF',
                        size: 30,
                        children: [],
                      },
                    ];
                  }
                  setChangeTemplate(false);
                  setBroadcastPreview(newBroadcastPreview);
                  setBroadcastContent(newBroadcastPreview.content);
                }
              });
            }}
            onClose={() => {
              setChangeTemplate(false);
              setIsUpdate((pre) => !pre);
            }}
            onCancel={() => {
              setChangeTemplate(false);
              setIsUpdate((pre) => !pre);
            }}
          >
            {broadcastPreview && (
              <Template setTemplate={setTemplate} template={template} />
            )}
          </Dialog>
        </Card.Content>
      </Card>
    </>
  );
};

export default BroadCastList;
